import React from 'react';

const TextSection2 = ({ title, paragraphs, padding = 16 }) => {
  const containerStyle = {
    backgroundColor: '#FFFFFF4D',
    borderRadius: 20,
    padding: padding,
    marginBottom: 32,
  };

  const titleStyle = {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
    
    color: '#212121',
  };

  const baseTextStyle = {
    fontSize: 16,
    lineHeight: '22px',
    
    color: '#212121',
    fontWeight: 400,
    marginBottom: 12,
  };

  return (
    <div style={containerStyle}>
      {title && <h3 style={titleStyle}>{title}</h3>}
      {paragraphs.map((text, index) => (
        <p key={index} style={baseTextStyle}>
          {text}
        </p>
      ))}
    </div>
  );
};

export default TextSection2;
